var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85.6 122.88",
    style: {
      enableBackground: "new 0 0 85.6 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.6,57.11c0-3.21-2.6-5.8-5.8-5.8c-3.21,0-5.8,2.6-5.8,5.8c0,11.43-2.74,20.87-8.29,27.17 c-5.03,5.7-12.63,8.99-22.9,8.99c-10.27,0-17.87-3.28-22.9-8.98c-5.56-6.3-8.29-15.74-8.29-27.18c0-3.21-2.6-5.8-5.8-5.8 c-3.21,0-5.8,2.6-5.8,5.8c0,14.25,3.69,26.33,11.19,34.84c5.52,6.26,12.96,10.5,22.33,12.15v9.52l-14.22,0 c-2.54,0-4.62,2.08-4.62,4.62v4.63h56.24v-4.63c0-2.54-2.08-4.62-4.62-4.62H52.07v-9.52c9.37-1.66,16.8-5.89,22.33-12.16 C81.9,83.44,85.6,71.36,85.6,57.11L85.6,57.11L85.6,57.11z M42.8,0c11.84,0,21.52,9.69,21.52,21.52v0.56H52.75v13.71l11.58,0v6.98 l-11.58,0v13.71h11.58v4.93c0,11.84-9.69,21.52-21.52,21.52c-11.84,0-21.52-9.69-21.52-21.52v-4.93h11.58V42.77H21.28v-6.98 l11.58,0V22.08H21.28v-0.56C21.28,9.69,30.96,0,42.8,0L42.8,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.874c812a25580abf9fd757ef6107cd5b.svg";
export { ForwardRef as ReactComponent };